import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import { isChrome, isFirefox, isIeEdge } from "@tightrope/lpscripts/browserdetect";
import Styles from "./css/ctadisclosurenewtab.module.scss";

var CtaDisclosureNewtab = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CtaDisclosureNewtab, _React$Component);

  function CtaDisclosureNewtab(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      data: {
        display: "none"
      }
    };
    return _this;
  }

  var _proto = CtaDisclosureNewtab.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.data) {
      this.setState({
        data: this.props.data
      });
    }

    if (this.props.browsers) {} else {
      this.setState({
        display: "block"
      });
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      id: Styles.ctadisclaimer,
      style: {
        display: this.state.display
      }
    }, isChrome() || isFirefox() ? /*#__PURE__*/React.createElement("p", null, "This free extension will update this browser's new tab page. By continuing, you acknowledge the ", /*#__PURE__*/React.createElement("a", {
      href: "/terms-of-service/",
      target: "_blank",
      className: Styles.bold
    }, "Terms of Service"), " and ", /*#__PURE__*/React.createElement("a", {
      href: "/privacy-policy/",
      target: "_blank",
      className: Styles.bold
    }, "Privacy Policy"), ", and that you may be presented with more optional offers.") : /*#__PURE__*/React.createElement("p", null, "By clicking Download, you agree to the ", /*#__PURE__*/React.createElement("a", {
      href: "/terms-of-service/",
      target: "_blank",
      className: Styles.bold
    }, "Terms of Service"), " and ", /*#__PURE__*/React.createElement("a", {
      href: "/privacy-policy/",
      target: "_blank",
      className: Styles.bold
    }, "Privacy Policy"), "."));
  };

  return CtaDisclosureNewtab;
}(React.Component);

export default CtaDisclosureNewtab;